import { NgModule } from '@angular/core';
import { SkyTextHighlightDirective } from './text-highlight.directive';
import { MutationObserverService } from '../mutation/mutation-observer-service';


export class SkyTextHighlightModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  declarations: [
    SkyTextHighlightDirective
  ],
  exports: [
    SkyTextHighlightDirective
  ],
  providers: [
    MutationObserverService
  ]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
